export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  // [turuta] Lista con seleccion multiple (multi_list en el servidor).
  { id: 20, key: 'MULTI_LIST' },
  { id: 7, key: 'CHECKBOX' },
];
